export default __webpack_public_path__ + "static/media/pic22.4e1cd0f6.jpg";